<template>
  <div>
    <div class="userCenter warp">
      <div class="leftMenu">
        <div class="leftMenuBox">
          <el-menu :default-active="defaultActive" active-text-color="#FF7800" router>
            <el-menu-item class="flex-start" ><span class="title flag"><i class="icon-add19 flag"></i>我的交易</span></el-menu-item>
            <el-menu-item class="flex-start" index="myOrder"><span class="title child">我的订单</span></el-menu-item>
            <el-menu-item class="flex-start" index="myOrder_serv"><span class="title child">我的服务订单</span></el-menu-item>
            <el-menu-item class="flex-start" index="orderAfterSale"><span class="title child">售后订单</span></el-menu-item>
            <!-- <el-menu-item class="flex-start" index="shopping-trolley"><span class="title child">我的采购单</span></el-menu-item> -->
            <el-menu-item class="flex-start" v-if="schoolFlag" index="receipt"><span class="title child">我的收货单</span></el-menu-item>
            <div style=" border-top: 1px dotted #E5E5E5;padding-top: 5px;margin-top: 20px;width:100%"></div>
            <el-menu-item class="flex-start" ><span class="title flag"><i class="icon-add15 flag"></i>企业信息管理</span></el-menu-item>
            
            <el-menu-item class="flex-start" index="userInfo"><span class="title child">个人资料</span></el-menu-item>
            
            <!-- <el-menu-item class="flex-start" index="userInfo2"><span class="title child">企业资料</span></el-menu-item> -->
            
            <el-menu-item class="flex-start" index="companyCertificate"><span class="title child">企业认证</span></el-menu-item>
            
            <!-- <el-menu-item class="flex-start" index="companyCertificate3"><span class="title child">安全中心设置</span></el-menu-item> -->
            <el-menu-item class="flex-start" index="signingAddress"><span class="title child">收货地址管理</span></el-menu-item>
            <div style=" border-top: 1px dotted #E5E5E5;padding-top: 5px;margin-top: 20px;width:100%"></div>
            <el-menu-item class="flex-start" ><span class="title flag"><i class="icon-add110 flag"></i>我的资产</span></el-menu-item>
            <el-menu-item class="flex-start" index="billPayServer"><span class="title child">账期支付服务</span></el-menu-item>
            <el-menu-item class="flex-start" index="shopData"><span class="title child">我的店铺</span></el-menu-item>
            <!-- index="personCenter" 用户中心 -->
            <div style=" border-top: 1px dotted #E5E5E5;padding-top: 5px;margin-top: 20px;width:100%"></div>
            <el-menu-item class="flex-start" ><span class="title flag"><i class="icon-Personal-information flag"></i>用户中心</span></el-menu-item>
            
            <el-menu-item class="flex-start" v-if="platform == 'b2c'" index="currency"><span class="title child">我的咖币</span></el-menu-item>
            <!-- <el-menu-item class="flex-start" index="message"><el-badge :value="userInfo.notRead" class="item"><span class="title">我的消息</span></el-badge></el-menu-item> -->
            <el-menu-item class="flex-start" index="message"><span class="title child">我的消息<span class="tip" v-if="userInfo.notRead">{{userInfo.notRead}}</span></span></el-menu-item>
            
            <el-menu-item class="flex-start" index="qaList"><span class="title child">我的问答</span></el-menu-item>
           
           <el-menu-item class="flex-start" index="myEvaluate"><span class="title child">我的评价</span></el-menu-item>
            
            <el-menu-item class="flex-start" index="couponPackage"><span class="title child">劵 包</span></el-menu-item>
            <!-- <el-menu-item class="flex-start" index="changePwd"><span class="title">更改密码</span></el-menu-item> -->
            <!-- <el-menu-item class="flex-start" index="changePhone"><span class="title child">更换手机号</span></el-menu-item> -->
            
            <el-menu-item class="flex-start" index="browseRecords"><span class="title child">浏览足迹</span></el-menu-item>
            <!-- <el-menu-item class="flex-start" index="unbindPhone"><span class="title">解绑手机</span></el-menu-item> -->
            <div style=" border-top: 1px dotted #E5E5E5;padding-top: 5px;margin-top: 20px;width:100%"></div>
            <el-menu-item class="flex-start" ><span class="title flag"><i class="icon-shoucang flag"></i>我的收藏</span></el-menu-item>
            <el-menu-item class="flex-start" index="favorites"><span class="title child">我的收藏</span></el-menu-item>
            <!-- <el-menu-item class="flex-start" index="favorites"><span class="title child">收藏店铺</span></el-menu-item> -->
            <!-- <el-menu-item class="flex-start" index=""><span class="title flag"><i class="el-icon-coordinate flag"></i>我的合同</span></el-menu-item>
            <el-menu-item class="flex-start" index="1"><span class="title child">待签署</span></el-menu-item>
            <el-menu-item class="flex-start" index="2"><span class="title child">履约中</span></el-menu-item>
            <el-menu-item class="flex-start" index="3"><span class="title child">已完结</span></el-menu-item>
            <el-menu-item class="flex-start" index="4"><span class="title child">已失效</span></el-menu-item> -->
            
            <!-- <el-menu-item class="flex-start" index=""><span class="title flag"><i class="el-icon-star-off flag"></i>财务中心</span></el-menu-item>
            <el-menu-item class="flex-start" index="favorites"><span class="title child">发票开具</span></el-menu-item>
            <el-menu-item class="flex-start" index="6"><span class="title child">已开发票</span></el-menu-item> -->
            

            
            
          </el-menu>
        </div>
      </div>
      <div class="userCenterInfo">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../api'
import {listSearchMixin} from '../../config/mixin'
import Cookie from 'js-cookie'
import {mapGetters} from 'vuex'
export default {
  mixins: [listSearchMixin],
  name: 'userCenter',
  data(){
    return{
      schoolFlag:true,
      platform:localStorage.getItem("platform")
    }
  },
  created () {
    if (!Cookie.get('token')) {
      this.$message.warning('请先登录')
      this.$store.commit('resetVuex')
      this.$router.push({path: '/login'})
    }
  },
  mounted (){
    this.isSchool()
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ]),
    defaultActive: function () {
      return this.$route.path.replace('/', '')
    }
  },
  methods: {
    isSchool(){
      let self = this;
      self.sendReq({
        url:api.isSchool,
         method: 'POST',
          data: {
            buyerUserId:self.userInfo.buyerUserId
          }
      }, (res) => {
          self.schoolFlag = res.data.isSchool
          localStorage.setItem("isSchool",res.data.isSchool);
        })
    }
  }
}
</script>
<style lang="scss">
  .main{
    background:#f5f5f5;
  }
</style>
<style lang="scss" scoped>
  .userCenter {
    margin-top: 30px;
    display: flex;
    margin-bottom: 30px;
    .leftMenu {
      width: 220px;
      // border: 1px solid #E5E5E5;
      margin-right: 16px;
      .leftMenuBox {
        
        >>> .el-menu {
          border-right: none;
          padding-bottom: 20px;
        }
        >>> .el-menu-item {
          height: 40px;
          padding: 0 !important;
          display: block;
          .title {
            
            width: 100%;
            
            line-height: 30px;
            // text-align: center;
            
            padding-left: 50px;
            border-left: 4px solid #ffffff;
            position: relative;
            i{
              position: absolute;
              top: 13px;
              left: 20px;
              height: 21px;
              margin-top:-5px;
              margin-right: 10px !important;
              
            }
          }
          .child{
            padding-left: 60px;
          }
          .flag{
            font-size: 18px;
            font-weight: 600;
            color: #000000;
            i{
              margin-top:-12px;
              margin-right: 5px;
              color: #606266;
            }
          }
          .tip{
            height: 18px;
            line-height: 18px;
            border-radius: 9px;
            color: #ffffff;
            font-size: 12px;
            padding: 0 5px;
            background-color: #FF7800;
            position: absolute;
            right: -35px;
            top: -8px;
          }
        }
        >>> .el-menu-item:focus, .el-menu-item:hover {
          background: none;
        }
        >>> .is-active {
          .title {
            border-left: 4px solid $mainColor;
            box-sizing: content-box;
          }
        }
      }
    }
    .userCenterInfo {
      background:#ffffff ;
      flex: 1;
    }
     
  }
  
</style>



// WEBPACK FOOTER //
// src/views/userCenter/userCenter.vue